import './index.scss'
import Swiper from 'swiper/swiper-bundle.min.js'
$("#nav1").addClass("active");

// 首页轮播
var banner = new Swiper('.banner .swiper-container', {
	  autoplay: {
      delay: 5000,
      disableOnInteraction: false,
	  },
	  speed:1000,
	  loop:true,//必须
});


// 产品
var swiper1 = new Swiper(".swiper1 .mySwiper", {
    navigation: {
        nextEl: ".swiper1 .swiper-button-next",
        prevEl: ".swiper1 .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
var swiper2 = new Swiper(".swiper2 .mySwiper", {
    navigation: {
        nextEl: ".swiper2 .swiper-button-next",
        prevEl: ".swiper2 .swiper-button-prev",
    },
     breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
var swiper3 = new Swiper(".swiper3 .mySwiper", {
    navigation: {
        nextEl: ".swiper3 .swiper-button-next",
        prevEl: ".swiper3 .swiper-button-prev",
    },
     breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
var swiper4 = new Swiper(".swiper4 .mySwiper", {
    navigation: {
        nextEl: ".swiper4 .swiper-button-next",
        prevEl: ".swiper4 .swiper-button-prev",
    },
     breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
var swiper5 = new Swiper(".swiper5 .mySwiper", {
    navigation: {
        nextEl: ".swiper5 .swiper-button-next",
        prevEl: ".swiper5 .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
var swiper6 = new Swiper(".swiper6 .mySwiper", {
    navigation: {
        nextEl: ".swiper6 .swiper-button-next",
        prevEl: ".swiper6 .swiper-button-prev",
    },
    breakpoints: {
      1280: {  //当屏幕宽度小于等于1280
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 30,
      },
      768: {  //当屏幕宽度小于等于768
        slidesPerView: 3,
        slidesPerGroup: 3,
        spaceBetween: 20,
      },
      320: {  //当屏幕宽度小于等于320
        slidesPerView: 2,
        slidesPerGroup: 2,
        spaceBetween: 10,
      }
    } 
});
$(".product-nav ul li").eq(0).addClass("active");
$(".product-list .product-swiper").eq(0).addClass("active");
$(".product-nav ul li").click(function() {
    let index = $(this).index();
    $(this).addClass('active').siblings().removeClass('active');
    $(".product-list .product-swiper").eq(index).addClass('active').siblings().removeClass('active');
})

// 留言
var message = new Swiper(".section5 .mySwiper", {
  slidesPerView: 2,
  slidesPerGroup: 2,
  spaceBetween: '9.43%',
  loop:true,
  autoplay: {
    delay: 5000,
    disableOnInteraction: false,
  },
  speed:1000,
  pagination: {
    el: ".swiper-pagination",
    clickable: true,
  },
  breakpoints: {
    1366: {  //当屏幕宽度小于等于1280
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: '9.43%',
    },
    768: {  //当屏幕宽度小于等于768
      slidesPerView: 2,
      slidesPerGroup: 2,
      spaceBetween: '5%',
    },
    320: {  //当屏幕宽度小于等于320
      slidesPerView: 1,
      slidesPerGroup: 1,
      spaceBetween: 0,
    }
  } 
});


if ( window.innerWidth> 1024) {
    $(window).on('scroll', function() {
        var scrollPosition = $(window).scrollTop(); // 获取当前滚动位置
        var modulePosition = $('.section4').offset().top; // 获取目标模块的顶部位置
        var moduleHeight = $('.section4').outerHeight(); // 获取模块的高度（如果需要检测到达底部）
         var windowHeight = $(window).height(); // 获取视口高度（可选，用于更复杂的检测）
        // 检查是否滚动到了模块的顶部或底部（根据需要选择）
        if (scrollPosition >= modulePosition && scrollPosition < $(".index .section4 .bottom").offset().top - windowHeight) { // 到达顶部（可根据需要调整距离）
            $(".section4 .left").addClass("fixed");
             $(".section4 .left").removeClass("fixed1");
            // 在这里执行你的代码，例如调用一个函数或执行动画等
            
            
        }
       else if (scrollPosition >= $(".index .section4 .bottom").offset().top - windowHeight && $("footer").offset().top) {
           $(".section4 .left").removeClass("fixed");
            $(".section4 .left").addClass("fixed1");
            
        }
        else{
            $(".section4 .left").removeClass("fixed");
             $(".section4 .left").removeClass("fixed1");
            // 在这里执行你的代码，例如调用一个函数或执行动画等
            
        }

        
    });
  }